module.exports = __webpack_public_path__ + "img/about_sharecode_3.afa0c519.png";